import IconSectionImage from '@assets/banner.svg';
import IconSectionText from '@assets/bio.svg';
import IconSectionFooter from '@assets/footerSection.svg';
import IconSectionHeader from '@assets/header.svg';
import IconSectionLinks from '@assets/pageLink.svg';
import IconSectionButton from '@assets/sections/button.svg';
import IconSectionSpacer from '@assets/spacer.svg';

import { homePath } from './constants.js';

export const mainMenuData = [
  {
    name: 'Broadcasts',
    path: `${homePath}`,
  },
  {
    name: 'Automations',
    path: `${homePath}/automations`,
  },
  {
    name: 'Templates',
    path: `${homePath}/emails`,
  },
  {
    name: 'Transactional',
    path: `${homePath}/transactional`,
  },
  {
    name: 'Settings',
    path: `${homePath}/settings`,
  },
];

export const contentMenuData = [
  {
    name: 'Content',
    type: `content`,
  },
  {
    name: 'Design',
    type: 'design',
  },
];

export const emailTypes = {
  broadcast: 'broadcast',
  workflow: 'workflow',
};

export const addSectionData = [
  {
    type: 'text',
    title: 'Text',
    text: 'Share basic content',
    icon: IconSectionText,
  },
  {
    type: 'image',
    title: 'Image',
    text: 'Share images',
    icon: IconSectionImage,
  },
  {
    type: 'header',
    title: 'Header',
    text: 'Share headers',
    icon: IconSectionHeader,
  },
  {
    type: 'button',
    title: 'Button',
    text: 'Share buttons',
    icon: IconSectionButton,
  },
  {
    type: 'link',
    title: 'Links',
    text: 'Share links',
    icon: IconSectionLinks,
  },
  {
    type: 'spacer',
    title: 'Spacer',
    text: 'Add space between sections',
    icon: IconSectionSpacer,
  },
];

export const footerSectionData = {
  type: 'footer',
  title: 'Footer',
  text: 'Footer of your email',
  icon: IconSectionFooter,
};

export const sectionType = {
  text: 'text',
  image: 'image',
  header: 'header',
  button: 'button',
  link: 'link',
  spacer: 'spacer',
  footer: 'footer',
};

export const listHeaderData = [
  {
    name: 'Broadcasts',
    width: '30%',
  },
  {
    name: 'Status',
    width: '15%',
  },
  {
    name: 'Recipients',
    width: '15%',
  },
  {
    name: 'Open rate',
    width: '15%',
  },
  {
    name: 'Click rate',
    width: '15%',
  },
  {
    name: 'Actions',
    width: '10%',
  },
];

export const emailTemplatesHeaderData = [
  {
    name: 'Email',
    width: '55%',
  },
  {
    name: 'Type',
    width: '19%',
  },
  {
    name: 'Status',
    width: '20%',
  },
  {
    name: 'Actions',
    width: '6%',
  },
];

export const contentMenuTypes = {
  content: 'content',
  design: 'design',
};

export const layoutTypes = {
  full: 'full',
  card: 'card',
};

export const sectionHeaderTypes = {
  Image: 'Image',
  ImageShape: 'ImageShape',
  ImageSize: 'ImageSize',
  ImageHyperlink: 'ImageHyperlink',
  Text: 'Text',
  View: 'View',
};
